<template>
  <div class="cover-setting-container">
    <div class="zhanwei4"></div>

    <!-- 顶部操作栏 -->
    <div class="header-action-bar">
      <div class="title-group">
        <h1 class="page-title">
          {{ $t("edit.cover.title") || "游戏基本信息与封面包装" }}
        </h1>
        <span class="sub-title"
          >配置游戏对外公开的名片信息、地理动线、多媒体画廊与故事背景</span
        >
      </div>
      <div class="btns">
        <el-button
          size="large"
          type="primary"
          @click="handleSave"
          class="save-top-btn"
          :loading="saving"
        >
          <el-icon><Check /></el-icon>
          {{ $t("edit.cover.save") || "保存配置" }}
        </el-button>
      </div>
    </div>

    <div class="cover-layout">
      <!-- 左侧：表单配置区 -->
      <div class="cover-form-area">
        <el-form
          :model="form"
          label-width="auto"
          label-position="top"
          class="clean-form"
        >
          <!-- 分组一：核心基本信息 -->
          <div class="form-section-block">
            <div class="section-title-row">
              <span class="indicator-bar"></span>
              <span class="section-name">核心基本信息</span>
            </div>

            <div class="form-row">
              <el-form-item :label="$t('edit.cover.gameTitle')" class="flex-2">
                <el-input
                  v-model="form.gameTitle"
                  placeholder="例如：迷失老城的钟楼秘钥"
                  size="large"
                  clearable
                />
              </el-form-item>
              <el-form-item label="游戏创作者/团队" class="flex-1">
                <el-input
                  v-model="form.author"
                  placeholder="创作者或团队署名"
                  size="large"
                  clearable
                />
              </el-form-item>
            </div>

            <div class="form-row triple-row">
              <el-form-item :label="$t('edit.cover.area')">
                <el-cascader
                  placeholder="请选择落地地区"
                  style="width: 100%"
                  v-model="form.region"
                  :options="selectRegion"
                  size="large"
                  clearable
                  @change="handleChange"
                />
              </el-form-item>
              <el-form-item :label="$t('edit.cover.gameLanguage')">
                <el-select
                  v-model="form.gameLanguage"
                  size="large"
                  style="width: 100%"
                >
                  <el-option label="繁体中文" value="繁体中文" />
                  <el-option label="简体中文" value="简体中文" />
                  <el-option label="English" value="English" />
                </el-select>
              </el-form-item>
              <el-form-item label="游戏分类" class="flex-1">
                <el-select
                  v-model="form.gameCategory"
                  size="large"
                  style="width: 100%"
                >
                  <el-option label="城市探索" value="城市探索" />
                  <el-option label="博物馆" value="博物馆" />
                  <el-option label="线上解谜" value="线上解谜" />
                </el-select>
              </el-form-item>
            </div>

            <div class="form-row">
              <el-form-item
                :label="$t('edit.cover.gameCategory')"
                class="flex-1"
              >
                <el-select
                  v-model="form.gameClass"
                  size="large"
                  style="width: 100%"
                >
                  <el-option label="单人角色剧本" value="单人角色剧本" />
                  <el-option label="多人角色剧本" value="多人角色剧本" />
                  <el-option label="亲子互动" value="亲子互动" />
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('edit.cover.tag')" class="flex-2">
                <el-select
                  v-model="form.tips"
                  multiple
                  filterable
                  allow-create
                  multiple-limit="5"
                  default-first-option
                  placeholder="选择或输入标签后回车（最多5个）"
                  size="large"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </div>
          </div>

          <!-- 分组二：地理位置与实景动线 -->
          <div class="form-section-block">
            <div class="section-title-row">
              <span class="indicator-bar"></span>
              <span class="section-name">地理位置与实景动线</span>
            </div>

            <div class="form-row">
              <el-form-item label="核心地标 / 场所名称" class="flex-2">
                <el-input
                  v-model="form.placeName"
                  placeholder="具体定位场所（例如：天后宫前街、科技馆主展厅）"
                  size="large"
                  clearable
                />
              </el-form-item>
              <el-form-item label="中心经度 (Lng)" class="flex-1">
                <el-input
                  v-model="form.log"
                  placeholder="113.123456"
                  size="large"
                  clearable
                >
                  <template #suffix>
                    <el-tooltip effect="dark" placement="top">
                      <template #content>
                        如何获取经纬度：<br />
                        方法：通过高德开放平台（精确获取）<br />

                        如果你需要批量或精确获取坐标，可以使用高德地图的坐标拾取器：<br />

                        1. 访问高德坐标拾取器

                        <a
                          href="https://lbs.amap.com/tools/picker"
                          target="_blank"
                          style="color: red"
                          >https://lbs.amap.com/tools/picker</a
                        ><br />

                        2. 在搜索框输入地址，或直接在地图上点击<br />

                        3. 左侧会显示对应的经纬度坐标<br />
                      </template>
                      <el-icon class="coord-help-icon"
                        ><QuestionFilled
                      /></el-icon>
                    </el-tooltip>
                  </template>
                </el-input>
              </el-form-item>
              <el-form-item label="中心纬度 (Lat)" class="flex-1">
                <el-input
                  v-model="form.lat"
                  placeholder="23.123456"
                  size="large"
                  clearable
                >
                  <template #suffix>
                    <el-tooltip effect="dark" placement="top">
                      <template #content>
                        如何获取经纬度：<br />
                        方法：通过高德开放平台（精确获取）<br />

                        如果你需要批量或精确获取坐标，可以使用高德地图的坐标拾取器：<br />

                        1. 访问高德坐标拾取器

                        <a
                          href="https://lbs.amap.com/tools/picker"
                          target="_blank"
                          style="color: red"
                          >https://lbs.amap.com/tools/picker</a
                        ><br />

                        2. 在搜索框输入地址，或直接在地图上点击<br />

                        3. 左侧会显示对应的经纬度坐标<br />
                      </template>
                      <el-icon class="coord-help-icon"
                        ><QuestionFilled
                      /></el-icon>
                    </el-tooltip>
                  </template>
                </el-input>
              </el-form-item>
            </div>

            <el-form-item :label="$t('edit.cover.address')">
              <el-input
                v-model="form.merchantAddress"
                placeholder="请输入完整详细地址，供玩家导航参考"
                size="large"
                clearable
              />
            </el-form-item>

            <div class="form-row geolocation-row">
              <el-form-item :label="$t('edit.cover.begin')" class="flex-1">
                <el-input
                  v-model="form.beginPoint"
                  placeholder="例如：景区东门游客接待中心"
                  size="large"
                />
              </el-form-item>
              <el-form-item :label="$t('edit.cover.end')" class="flex-1">
                <el-input
                  v-model="form.endPoint"
                  placeholder="例如：钟楼广场西侧出口"
                  size="large"
                />
              </el-form-item>
            </div>

            <div class="form-row">
              <el-form-item :label="$t('edit.cover.Facilities_along_way')">
                <el-input
                  v-model="form.along"
                  placeholder="沿途洗手间、便利店、无障碍通道等说明"
                  size="large"
                />
              </el-form-item>
              <el-form-item :label="$t('edit.cover.transportation')">
                <el-input
                  v-model="form.transportation"
                  placeholder="例如：地铁2号线直达，建议步行参与"
                  size="large"
                />
              </el-form-item>
            </div>
          </div>

          <!-- 分组三：游玩规格与时段规则 -->
          <div class="form-section-block">
            <div class="section-title-row">
              <span class="indicator-bar"></span>
              <span class="section-name">游玩规格与规则建议</span>
            </div>

            <div class="form-row">
              <el-form-item :label="$t('edit.cover.opening_hours')">
                <el-input
                  v-model="form.openHour"
                  placeholder="例如: 09:00 - 18:00 (17:00停止入场)"
                  size="large"
                />
              </el-form-item>
              <el-form-item :label="$t('edit.cover.experience_time')">
                <el-input
                  v-model="form.experienceTime"
                  placeholder="例如: 全年开放 / 每周二至周日"
                  size="large"
                />
              </el-form-item>
            </div>

            <div class="form-row triple-row">
              <el-form-item :label="$t('edit.cover.walking_distance')">
                <el-input v-model="form.walk" placeholder="公里数" size="large">
                  <template #append>km</template>
                </el-input>
              </el-form-item>
              <el-form-item :label="$t('edit.cover.estimated_time')">
                <el-input
                  v-model="form.estimateTime"
                  placeholder="耗时描述"
                  size="large"
                />
              </el-form-item>
              <el-form-item :label="$t('edit.cover.player_age')">
                <el-input
                  v-model="form.playerAge"
                  placeholder="例如: 8岁以上 / 全年龄"
                  size="large"
                />
              </el-form-item>
            </div>

            <div class="form-row">
              <el-form-item :label="$t('edit.cover.difficulty')" class="flex-1">
                <div class="rate-wrapper">
                  <el-rate v-model="form.difficulty" size="large" />
                  <span class="rate-text">{{ difficultyLabel }}</span>
                </div>
              </el-form-item>
              <el-form-item :label="$t('edit.cover.playTime')" class="flex-1">
                <el-input-number
                  v-model="form.playTime"
                  :min="10"
                  :max="240"
                  :step="10"
                  size="large"
                  style="width: 100%"
                />
              </el-form-item>
            </div>
          </div>

          <!-- 分组四：多媒体资源配置（封面 + 画廊） -->
          <div class="form-section-block">
            <div class="section-title-row">
              <span class="indicator-bar"></span>
              <span class="section-name">多媒体资源视觉配置</span>
            </div>

            <div class="media-setting-box">
              <!-- 游戏封面 -->
              <div class="media-item-box">
                <div class="media-item-info">
                  <span class="label-text">{{
                    $t("edit.cover.gameCover")
                  }}</span>
                  <p class="desc-text">
                    游戏在大厅与列表卡片展示的核心封面图。推荐比例 4:3，支持
                    JPG/PNG/WEBP (5MB 内)
                  </p>
                </div>
                <div class="upload-area-wrapper">
                  <el-upload
                    class="avatar-uploader"
                    :action="UpdateApi"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess"
                    :before-upload="beforeAvatarUpload"
                    :limit="1"
                    :file-list="fileList"
                    :disabled="allowUpload"
                  >
                    <div v-if="form.gameCover" class="avatar-preview-box">
                      <el-image
                        :src="form.gameCover"
                        class="avatar"
                        alt="游戏封面"
                        fit="cover"
                      />
                      <div class="hover-mask">
                        <span
                          class="del-btn"
                          @click.stop="clearImage"
                          title="删除并重新上传"
                        >
                          <el-icon><DeleteFilled /></el-icon>
                        </span>
                      </div>
                    </div>
                    <div v-else class="upload-placeholder">
                      <el-icon class="avatar-uploader-icon"><Plus /></el-icon>
                      <span class="up-txt">上传封面图</span>
                    </div>
                  </el-upload>
                </div>
              </div>

              <!-- 详情页轮播画廊 -->
              <div class="media-item-box column-layout">
                <div class="media-item-info">
                  <span class="label-text">{{
                    $t("edit.cover.slideshow")
                  }}</span>
                  <p class="desc-text">
                    移动端详情页展示的多图相册。最多上传 5
                    张，可长按或拖拽卡片调整展示顺序
                  </p>
                </div>

                <div class="slideshow-container">
                  <VueDraggable
                    ref="el"
                    v-model="fileList2"
                    class="slideshow-draggable"
                    :animation="150"
                  >
                    <div
                      v-for="(item, index) in fileList2"
                      :key="item.uid || index"
                      class="slideshow-card"
                    >
                      <el-image
                        :src="item.url"
                        fit="cover"
                        class="slideshow-image"
                      />
                      <div class="slideshow-mask">
                        <span
                          class="del-btn-round"
                          @click.stop="clearImage2(index)"
                          title="删除此图"
                        >
                          <el-icon><DeleteFilled /></el-icon>
                        </span>
                      </div>
                    </div>
                  </VueDraggable>

                  <el-upload
                    v-if="fileList2.length < 5"
                    :file-list="fileList2"
                    :action="UpdateApi"
                    :on-success="handleAvatarSuccess2"
                    :before-upload="beforeAvatarUpload2"
                    :show-file-list="false"
                    list-type="picture-card"
                    class="slideshow-uploader"
                  >
                    <el-icon><Plus /></el-icon>
                  </el-upload>
                </div>
              </div>
            </div>
          </div>

          <!-- 分组五：故事文本介绍 -->
          <div class="form-section-block">
            <div class="section-title-row">
              <span class="indicator-bar"></span>
              <span class="section-name">背景故事与详细介绍</span>
            </div>

            <el-form-item :label="$t('edit.cover.gameDescription')">
              <el-input
                v-model="form.gameDesc"
                type="textarea"
                placeholder="请详细描述游戏的故事背景、玩家使命与核心探索看点..."
                size="large"
                rows="6"
                show-word-limit
                maxlength="500"
              />
            </el-form-item>

            <el-form-item :label="$t('edit.cover.research_characteristics')">
              <el-input
                v-model="form.features"
                type="textarea"
                placeholder="描述其独有的研学意义、团队协作或空间文化探索特性..."
                size="large"
                rows="4"
                show-word-limit
                maxlength="300"
              />
            </el-form-item>

            <el-form-item :label="$t('edit.cover.introduction')">
              <el-input
                v-model="form.introductionLink"
                placeholder="外部参考链接、公众号推文或全景VR外链 (选填)"
                size="large"
                clearable
              />
            </el-form-item>
          </div>
        </el-form>
      </div>

      <!-- 右侧：黑曜石移动端真机拟物视口 -->
      <div class="cover-preview-area">
        <div class="preview-header">
          <span class="badge-dot"></span>
          <span>{{ $t("edit.cover.titleApp") || "App 详情页实时视口" }}</span>
        </div>

        <div class="mockup-phone">
          <div class="phone-top-bar">
            <div class="notch"></div>
          </div>

          <div class="phone-screen">
            <!-- 顶部悬浮控制小圆标 -->
            <div class="app_icon">
              <span class="back-circle">
                <el-icon size="14" color="#ffffff"><ArrowLeft /></el-icon>
              </span>
              <span class="more-circle">
                <el-icon size="14" color="#ffffff"><More /></el-icon>
              </span>
            </div>

            <!-- 大封面背景 -->
            <div class="app_cover">
              <el-image
                class="cover-img"
                :src="
                  form.gameCover ||
                  'https://s3-ap-northeast-1.amazonaws.com/popworld-tourguide-storage2/images/game_default_cover.png?1717571493'
                "
                fit="cover"
              />
            </div>

            <!-- 可滑动内容区 -->
            <div class="screen-scroll-container">
              <!-- 游戏标题与创作者 -->
              <div class="author_info">
                <h4 class="mock-game-title">
                  {{ form.gameTitle || "未命名游戏" }}
                </h4>
                <p class="mock-author">
                  <el-icon class="author-icon"><User /></el-icon>
                  By {{ form.author || "平台创作者" }}
                </p>
                <div class="category-chip" v-if="form.gameClass">
                  {{ form.gameClass }}
                </div>
              </div>

              <!-- 规格清单 -->
              <div class="about-card">
                <h5 class="section-sub-title">
                  {{ $t("edit.cover.app1") || "基本概况" }}
                </h5>
                <div class="spec-list">
                  <div class="spec-item">
                    <el-icon class="spec-icon"><QuestionFilled /></el-icon>
                    <span class="spec-label"
                      >{{ $t("edit.cover.app2") || "难度" }}：</span
                    >
                    <el-rate v-model="form.difficulty" disabled size="small" />
                  </div>
                  <div class="spec-item">
                    <el-icon class="spec-icon"><AlarmClock /></el-icon>
                    <span class="spec-label"
                      >{{ $t("edit.cover.app3") || "预计用时" }}：</span
                    >
                    <span class="spec-val">{{ form.playTime }} 分钟</span>
                  </div>
                  <div class="spec-item">
                    <el-icon class="spec-icon"><Location /></el-icon>
                    <span class="spec-label"
                      >{{ $t("edit.cover.app4") || "起点位置" }}：</span
                    >
                    <span class="spec-val truncate">{{
                      form.placeName || form.beginPoint || "具体地点待定"
                    }}</span>
                  </div>
                </div>
              </div>

              <!-- 故事背景介绍 -->
              <div class="introduce-card">
                <h5 class="section-sub-title">
                  {{ $t("edit.cover.app5") || "剧情与体验简介" }}
                </h5>
                <p class="introduce-text">
                  {{ form.gameDesc || "暂无游戏介绍，请在左侧表单输入。" }}
                </p>
              </div>
            </div>

            <!-- 底部操作按钮 -->
            <div class="mock-bottom-bar">
              <div class="start-btn">
                <span>开启实景探索</span>
                <el-icon><Right /></el-icon>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="zhanwei3"></div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import {
  Right,
  Plus,
  More,
  ArrowLeft,
  AlarmClock,
  QuestionFilled,
  Location,
  User,
  DeleteFilled,
  Check,
} from "@element-plus/icons-vue";
import { ElNotification, ElMessage } from "element-plus";
import { vDraggable, VueDraggable } from "vue-draggable-plus";
import { area } from "@/components/edit/city";

export default defineComponent({
  name: "CoverSetting",
  components: {
    DeleteFilled,
    Right,
    Plus,
    More,
    ArrowLeft,
    AlarmClock,
    QuestionFilled,
    Location,
    User,
    Check,
    VueDraggable,
  },
  directives: {
    draggable: vDraggable,
  },
  data(): any {
    return {
      saving: false,
      form: {
        openHour: "",
        belongId: "",
        createTime: "",
        beginPoint: "",
        endPoint: "",
        walk: "",
        estimateTime: "",
        along: "",
        multiplayer: "",
        playerAge: "",
        difficulty: 3,
        region: [],
        gameClass: "单人角色剧本",
        gameCover: "",
        gameDesc: "",
        features: "",
        gameLanguage: "简体中文",
        gameLevelId: "",
        gameTitle: "",
        author: "",
        id: "",
        playTime: 60,
        status: 0,
        updateTime: null,
        startTime: "",
        experienceTime: "",
        begin: "",
        transportation: "",
        merchantAddress: "",
        introductionLink: "",
        gameCategory: "城市探索",
        placeName: "",
        log: "",
        lat: "",
        tips: [],
        carousel: "",
      },
      fileList: [],
      fileList2: [],
      selectRegion: area,
      options: [
        { value: "庙宇", label: "庙宇" },
        { value: "澳门", label: "澳门" },
        { value: "广州", label: "广州" },
        { value: "佛山", label: "佛山" },
        { value: "深圳", label: "深圳" },
        { value: "博物馆", label: "博物馆" },
        { value: "非遗", label: "非遗" },
        { value: "环保", label: "环保" },
        { value: "动物园", label: "动物园" },
        { value: "植物园", label: "植物园" },
        { value: "科学馆", label: "科学馆" },
        { value: "历史街区", label: "历史街区" },
        { value: "红色主题", label: "红色主题" },
      ],
    };
  },
  computed: {
    allowUpload(): boolean {
      return Boolean(this.form.gameCover);
    },
    UpdateApi(): string {
      return process.env.VUE_APP_Update_API || "";
    },
    difficultyLabel(): string {
      const map: Record<number, string> = {
        1: "简单新手",
        2: "初窥门径",
        3: "适中挑战",
        4: "逻辑烧脑",
        5: "硬核推理",
      };
      return map[this.form.difficulty] || "适中挑战";
    },
  },
  mounted() {
    if (this.$route.params.id && this.$route.params.id !== "0") {
      const game = this.$store.state.game.games?.find(
        (item: any) => item.id == this.$route.params.id
      );

      if (game) {
        this.form = { ...this.form, ...game };

        if (this.form.region) {
          if (typeof this.form.region === "string") {
            this.form.region = this.form.region.split(",").filter(Boolean);
          }
        } else {
          this.form.region = [];
        }

        if (this.form.tips && typeof this.form.tips === "string") {
          try {
            this.form.tips = JSON.parse(this.form.tips);
          } catch (e) {
            this.form.tips = [];
          }
        }

        if (this.form.carousel) {
          this.fileList2 = this.form.carousel
            .split(",")
            .filter(Boolean)
            .map((url: string, index: number) => ({
              url,
              uid: `${Date.now()}_${index}`,
              name: `file-${index}`,
            }));
        }

        if (game.gameLevelId) {
          this.fetchGameList(game.gameLevelId);
        }
      }
    }
  },
  methods: {
    handleSave() {
      this.saving = true;
      const { updateTime, ...formWithoutUpdateTime } = this.form;
      const payload: any = { ...formWithoutUpdateTime };

      payload.tips = JSON.stringify(payload.tips || []);
      payload.carousel = this.fileList2.map((item: any) => item.url).join(",");
      payload.region = Array.isArray(this.form.region)
        ? this.form.region.join(",")
        : this.form.region;

      this.$store
        .dispatch("game/updateGame", { gameBean: payload })
        .then(() => {
          ElMessage.success("游戏基本信息与封面保存成功");
        })
        .catch((err: any) => {
          ElMessage.error("保存失败: " + (err.message || err));
        })
        .finally(() => {
          this.saving = false;
        });
    },
    fetchGameList(gameLevelId: string) {
      this.$store
        .dispatch("game/getGameLevelList", { gameLevelId })
        .catch((err: any) => {
          console.error(err);
        });
    },
    beforeAvatarUpload(file: File): boolean {
      const isAllowed =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/webp";
      const isLt5M = file.size / 1024 / 1024 < 5;

      if (!isAllowed) {
        ElNotification.warning({
          message: "仅支持 JPG/PNG/WEBP 格式图片",
          offset: 100,
        });
        return false;
      }
      if (!isLt5M) {
        ElNotification.warning({
          message: "图片体积不可超过 5MB",
          offset: 100,
        });
        return false;
      }
      return true;
    },
    beforeAvatarUpload2(file: File): boolean {
      return this.beforeAvatarUpload(file) && this.fileList2.length < 5;
    },
    handleAvatarSuccess(response: any) {
      if (response?.data?.returnFileUrl) {
        this.form.gameCover = response.data.returnFileUrl;
      }
    },
    handleAvatarSuccess2(response: any) {
      if (response?.code === 200 && response?.data?.returnFileUrl) {
        this.fileList2.push({
          url: response.data.returnFileUrl,
          uid: Date.now(),
          name: `img-${Date.now()}`,
          status: "finished",
        });
      }
    },
    // 1. 删除多图中的某一项
    async clearImage2(index: number) {
      const targetFile = this.fileList2[index];
      if (!targetFile) return;

      // 获取文件名或路径（根据实际数据结构调整，如 targetFile.name 或 targetFile.url）
      const fileName = targetFile.name || targetFile.url;

      try {
        if (fileName) {
          await this.$store.dispatch("user/delFile", { fileName });
        }
        this.fileList2.splice(index, 1);
      } catch (error) {
        console.error("删除图片失败:", error);
      }
    },

    // 2. 清空单图封面
    async clearImage() {
      const fileName = this.form.gameCover;

      try {
        if (fileName) {
          await this.$store.dispatch("user/delFile", { fileName });
        }
        this.form.gameCover = "";
        this.fileList = [];
      } catch (error) {
        console.error("删除封面失败:", error);
      }
    },
    handleChange(val: any) {
      // 级联改变处理
    },
  },
});
</script>

<style lang="less" scoped>
@primary-color: #5d5fef;
@primary-hover: #4b4de0;
@primary-light: #f0f2ff;
@text-main: #0f172a;
@text-sub: #475569;
@text-muted: #94a3b8;
@border-color: #e2e8f0;
@card-border: #f1f5f9;
@danger-color: #ef4444;

.zhanwei4 {
  height: 20px;
}
.zhanwei3 {
  height: 32px;
}

.cover-setting-container {
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 20px;
  box-sizing: border-box;
}

// 顶部头部与保存操作栏
.header-action-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #ffffff;
  padding: 20px 28px;
  border-radius: 14px;
  border: 1px solid @card-border;
  box-shadow: 0 4px 18px rgba(15, 23, 42, 0.03);
  margin-bottom: 24px;

  .title-group {
    .page-title {
      font-size: 18px;
      font-weight: 700;
      color: @text-main;
      margin: 0 0 4px 0;
    }
    .sub-title {
      font-size: 12.5px;
      color: @text-muted;
    }
  }

  .save-top-btn {
    height: 40px;
    padding: 0 26px;
    border-radius: 8px;
    background-color: @primary-color;
    border-color: @primary-color;
    font-weight: 600;
    box-shadow: 0 4px 12px rgba(93, 95, 239, 0.25);
    transition: all 0.2s ease;

    .el-icon {
      margin-right: 6px;
    }

    &:hover {
      background-color: @primary-hover;
      border-color: @primary-hover;
      transform: translateY(-1px);
      box-shadow: 0 6px 16px rgba(93, 95, 239, 0.35);
    }
  }
}

// 双栏布局
.cover-layout {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 36px;
  box-sizing: border-box;

  @media (max-width: 1080px) {
    flex-direction: column;
    align-items: center;
  }
}

// 左侧表单排版
.cover-form-area {
  flex: 1;
  width: 100%;
  background: #ffffff;
  padding: 32px 36px;
  border-radius: 16px;
  border: 1px solid @card-border;
  box-shadow: 0 4px 24px -2px rgba(15, 23, 42, 0.04);
  box-sizing: border-box;

  .clean-form {
    // 逻辑分组
    .form-section-block {
      margin-bottom: 34px;

      .section-title-row {
        display: flex;
        align-items: center;
        gap: 10px;
        margin-bottom: 20px;
        padding-bottom: 8px;
        border-bottom: 1px solid @border-color;

        .indicator-bar {
          width: 4px;
          height: 16px;
          background: @primary-color;
          border-radius: 2px;
        }

        .section-name {
          font-size: 15px;
          font-weight: 700;
          color: @text-main;
        }
      }

      .form-row {
        display: flex;
        gap: 16px;

        .el-form-item {
          flex: 1;
          margin-bottom: 20px;
        }

        .flex-2 {
          flex: 2;
        }
        .flex-1 {
          flex: 1;
        }

        @media (max-width: 640px) {
          flex-direction: column;
          gap: 0;
        }
      }

      :deep(.el-form-item) {
        margin-bottom: 20px;

        .el-form-item__label {
          font-size: 13px;
          font-weight: 600;
          color: @text-sub;
          padding-bottom: 6px;
        }
      }

      :deep(.el-input__wrapper),
      :deep(.el-textarea__inner) {
        border-radius: 8px;
        box-shadow: 0 0 0 1px @border-color inset;
        transition: all 0.2s ease;

        &:hover {
          box-shadow: 0 0 0 1px #cbd5e1 inset;
        }

        &.is-focus,
        &:focus {
          box-shadow: 0 0 0 1px @primary-color inset !important;
        }
      }

      :deep(.el-input-group__append) {
        background-color: #f8fafc;
        border-radius: 0 8px 8px 0;
        box-shadow: 0 0 0 1px @border-color inset;
        color: @text-sub;
        font-weight: 600;
      }
    }
  }

  .rate-wrapper {
    height: 40px;
    display: flex;
    align-items: center;
    gap: 12px;

    .rate-text {
      font-size: 12px;
      font-weight: 600;
      color: @primary-color;
    }
  }

  .coord-help-icon {
    cursor: pointer;
    color: @text-muted;
    transition: color 0.2s;

    &:hover {
      color: @primary-color;
    }
  }

  // 多媒体上传区域
  .media-setting-box {
    display: flex;
    flex-direction: column;
    gap: 20px;

    .media-item-box {
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: #f8fafc;
      border: 1px solid @border-color;
      padding: 20px;
      border-radius: 12px;
      gap: 20px;

      &.column-layout {
        flex-direction: column;
        align-items: flex-start;
      }

      .media-item-info {
        flex: 1;

        .label-text {
          display: block;
          font-size: 14px;
          font-weight: 700;
          color: @text-main;
          margin-bottom: 4px;
        }
        .desc-text {
          font-size: 12px;
          color: @text-muted;
          margin: 0;
          line-height: 1.5;
        }
      }

      .upload-area-wrapper {
        display: flex;
        align-items: flex-end;
        gap: 12px;
      }
    }
  }

  // 封面图 4:3 上传器
  .avatar-uploader {
    border-radius: 10px;
    cursor: pointer;
    overflow: hidden;
    width: 160px;
    height: 120px;
    transition: all 0.2s;
    background: #ffffff;
    border: 1.5px dashed #cbd5e1;

    &:hover {
      border-color: @primary-color;
      background: @primary-light;
    }

    .avatar-preview-box {
      position: relative;
      width: 100%;
      height: 100%;

      .avatar {
        width: 100%;
        height: 100%;
        display: block;
      }

      .hover-mask {
        position: absolute;
        inset: 0;
        background: rgba(15, 23, 42, 0.55);
        backdrop-filter: blur(2px);
        display: flex;
        justify-content: center;
        align-items: center;
        opacity: 0;
        transition: opacity 0.2s ease;

        .del-btn {
          width: 34px;
          height: 34px;
          border-radius: 50%;
          background: #ffffff;
          color: @danger-color;
          display: flex;
          justify-content: center;
          align-items: center;
          box-shadow: 0 3px 8px rgba(0, 0, 0, 0.15);
          transition: transform 0.2s;

          &:hover {
            transform: scale(1.12);
          }
        }
      }

      &:hover .hover-mask {
        opacity: 1;
      }
    }

    .upload-placeholder {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 6px;

      .avatar-uploader-icon {
        font-size: 22px;
        color: @text-sub;
      }

      .up-txt {
        font-size: 12px;
        font-weight: 600;
        color: @text-muted;
      }
    }
  }

  // 轮播画廊
  .slideshow-container {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    width: 100%;

    .slideshow-draggable {
      display: flex;
      flex-wrap: wrap;
      gap: 12px;
    }

    .slideshow-card {
      width: 108px;
      height: 108px;
      border-radius: 10px;
      overflow: hidden;
      position: relative;
      border: 1px solid @border-color;
      cursor: grab;
      background: #ffffff;

      &:active {
        cursor: grabbing;
      }

      .slideshow-image {
        width: 100%;
        height: 100%;
        display: block;
      }

      .slideshow-mask {
        position: absolute;
        inset: 0;
        background: rgba(15, 23, 42, 0.55);
        backdrop-filter: blur(2px);
        display: flex;
        justify-content: center;
        align-items: center;
        opacity: 0;
        transition: opacity 0.2s ease;

        .del-btn-round {
          width: 32px;
          height: 32px;
          border-radius: 50%;
          background: #ffffff;
          color: @danger-color;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          transition: transform 0.2s;

          &:hover {
            transform: scale(1.15);
          }
        }
      }

      &:hover .slideshow-mask {
        opacity: 1;
      }
    }

    :deep(.slideshow-uploader .el-upload--picture-card) {
      width: 108px;
      height: 108px;
      background-color: #ffffff;
      border: 1.5px dashed #cbd5e1;
      border-radius: 10px;
      transition: all 0.2s ease;

      &:hover {
        border-color: @primary-color;
        background-color: @primary-light;
        color: @primary-color;
      }
    }
  }
}

// 右侧黑曜石移动端真机视口
.cover-preview-area {
  width: 320px;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;

  .preview-header {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
    font-weight: 600;
    color: @text-sub;
    margin-bottom: 14px;

    .badge-dot {
      width: 8px;
      height: 8px;
      background: #10b981;
      border-radius: 50%;
      box-shadow: 0 0 6px rgba(16, 185, 129, 0.6);
    }
  }

  .mockup-phone {
    width: 290px;
    height: 560px;
    background: #ffffff;
    border-radius: 36px;
    border: 10px solid #0f172a;
    box-shadow: 0 16px 36px -6px rgba(15, 23, 42, 0.18);
    position: relative;
    overflow: hidden;
    display: flex;
    flex-direction: column;

    .phone-top-bar {
      width: 100%;
      height: 20px;
      display: flex;
      justify-content: center;
      background: #ffffff;
      z-index: 10;

      .notch {
        width: 76px;
        height: 12px;
        background: #0f172a;
        border-bottom-left-radius: 6px;
        border-bottom-right-radius: 6px;
      }
    }

    .phone-screen {
      flex: 1;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      background: #f8fafc;
      position: relative;

      .app_icon {
        position: absolute;
        top: 10px;
        left: 0;
        right: 0;
        display: flex;
        justify-content: space-between;
        padding: 0 12px;
        z-index: 10;

        .back-circle,
        .more-circle {
          width: 28px;
          height: 28px;
          border-radius: 50%;
          background: rgba(15, 23, 42, 0.4);
          backdrop-filter: blur(4px);
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
        }
      }

      .app_cover {
        width: 100%;
        height: 160px;
        background-color: #e2e8f0;
        overflow: hidden;
        flex-shrink: 0;

        .cover-img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .screen-scroll-container {
        flex: 1;
        overflow-y: auto;
        padding: 0 14px 14px;
        display: flex;
        flex-direction: column;
        gap: 10px;

        .author_info {
          background: #ffffff;
          padding: 14px 16px;
          margin-top: 26px;
          border-radius: 12px;
          position: relative;
          z-index: 2;
          box-shadow: 0 2px 8px rgba(15, 23, 42, 0.05);

          .mock-game-title {
            margin: 0 0 6px 0;
            font-size: 15px;
            font-weight: 700;
            color: @text-main;
            line-height: 1.35;
          }

          .mock-author {
            margin: 0 0 8px 0;
            font-size: 11.5px;
            color: @text-muted;
            display: flex;
            align-items: center;
            gap: 4px;

            .author-icon {
              font-size: 12px;
            }
          }

          .category-chip {
            display: inline-block;
            font-size: 10.5px;
            font-weight: 600;
            color: @primary-color;
            background: @primary-light;
            padding: 2px 8px;
            border-radius: 4px;
          }
        }

        .about-card,
        .introduce-card {
          background: #ffffff;
          padding: 12px 14px;
          border-radius: 10px;
          box-shadow: 0 2px 6px rgba(15, 23, 42, 0.03);

          .section-sub-title {
            margin: 0 0 8px 0;
            font-size: 12px;
            font-weight: 700;
            color: @text-main;
          }
        }

        .spec-list {
          display: flex;
          flex-direction: column;
          gap: 6px;

          .spec-item {
            display: flex;
            align-items: center;
            font-size: 11.5px;
            color: @text-sub;

            .spec-icon {
              margin-right: 6px;
              color: @text-muted;
              font-size: 13px;
            }

            .spec-label {
              color: @text-muted;
            }

            .spec-val {
              color: @text-main;
              font-weight: 600;

              &.truncate {
                max-width: 110px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }
          }
        }

        .introduce-text {
          margin: 0;
          font-size: 11.5px;
          color: @text-sub;
          line-height: 1.6;
          white-space: pre-wrap;
          word-break: break-all;
        }
      }

      .mock-bottom-bar {
        background: #ffffff;
        padding: 8px 14px 12px;
        border-top: 1px solid @border-color;

        .start-btn {
          width: 100%;
          height: 36px;
          background: @primary-color;
          color: #ffffff;
          font-weight: 600;
          font-size: 12.5px;
          border-radius: 18px;
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 6px;
          box-shadow: 0 3px 8px rgba(93, 95, 239, 0.28);
          cursor: default;
        }
      }
    }
  }
}
</style>
